import { Get, Post } from "../axios.config";

/** @author jiao 2019年12月23日12:22:09
 * 产品对接：张确 服务端对接：袁鑫
 * getVipActivityId 获取赠送会员活动id
 * method: get
 * url: /v1/vip/activity
 * API文档: https://yapi.quickcan.com/project/347/interface/api/9144
 *
 **/
export function getVipActivityId({ activityId, deviceId }) {
    const url = "v1/vip/activity";
    return Get({
        url,
        data: {
            activity_id: activityId
        },
        headers: {
            "X-Device": deviceId
        }
    });
}
/** @author jiao 2019年12月23日14:31:37
 * 产品对接： 张确 服务端对接： 苏素飞
 * getTopicList 获取限免作品
 * method: get
 * url: /v1/vip/banner/topic_banner
 * API文档: https: //yapi.quickcan.com/project/329/interface/api/4045
 *
 * 参数名                           是否必须参数         类型            备注
 * @non_iap_supported_device        否                boolean         是否是越狱设备，true表示是，4.2版本添加
 * @banner_ids                      否                string
 **/
export function getTopicList() {
    const url = "v1/vip/banner/topic_banner";
    return Get({
        url
    });
}
/** @author jiao 2019年12月24日16:12:32
 * 产品对接： 张确 服务端对接： 诗祥
 * getMembership 会员身份
 * method: get
 * url: /v1/fox/horadric/pay
 * API文档: https://yapi.quickcan.com/project/592/interface/api/7332
 * 参数名称      是否必须   示例    备注
 * data_types   是       1,2,3   kkb_common: 1 kk币公共埋点数据vip_common: 2 用户会员身份公共埋点数据comic_buy_common: 3 用户漫画购买公共埋点数                                 据  comic_pay_common:4 漫画付费状态相公共埋点数据pay_user_common:5 付费用户身份相关公共埋点数据
 * topic_id     是          1             漫画付费相关(4)必传
 * comic_id     是          1             漫画付费相关(4)必传
 **/
export function getMembership({ type }) {
    const url = "v1/fox/horadric/pay";
    return Get({
        url,
        data: {
            success: 1,
            data_types: type
        },
    });
}
/** @author jiao 2019年12月24日11:38:40
 * 产品对接： 张确 服务端对接： 袁鑫
 * postAssignVip 领取会员天数
 * method: post
 * url: /v1/vip/assign
 * API文档: https://yapi.quickcan.com/project/347/interface/api/9168
 *
 * 参数名                           是否必须参数         类型            备注
 * activity_id                      是                 int             活动id 从url中获取
 **/
export function postAssignVip({ activityId, deviceId }) {
    const url = "v1/vip/assign";
    return Post({
        url,
        data: {
            activity_id: activityId
        },
        headers: {
            "X-Device": deviceId
        }
    });
}



// WEBPACK FOOTER //
// ./src/api/pay/free_vip.api.js